<template>
  <div class="list_page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="92px">
        <!-- 反馈单号 -->
        <el-form-item label="反馈单号">
          <el-input
            v-model="queryParams.feedbackFormId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <!-- 车型 -->
        <el-form-item label="车型">
          <el-input v-model="queryParams.carModel" placeholder="请输入车型" />
        </el-form-item>
        <!-- 所属经销商 -->
        <!--        <el-form-item label="所属经销商">
          <el-input
            v-model="queryParams.customerName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>-->
        <!-- 状态 -->
        <el-form-item label="状态">
          <el-select filterable clearable v-model="queryParams.status">
            <el-option label="未提交" :value="0"></el-option>
            <el-option label="处理中" :value="1"></el-option>
            <el-option label="已关闭" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- 零部件类别 -->
        <el-form-item label="零部件类别">
          <el-select v-model="queryParams.componentType" filterable clearable>
            <el-option
              v-for="(item, index) in componentCategoryList"
              :key="index"
              :label="item[componentCategoryName.get('zh')]"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 故障现象描述 -->
        <el-form-item :label="'故障现象描述'">
          <el-input
            v-model="queryParams.questionContent"
            placeholder="请输入故障现象描述"
          ></el-input>
        </el-form-item>
        <!-- 问题类型 -->
        <el-form-item label="问题类型">
          <el-select filterable clearable v-model="queryParams.createType">
            <el-option label="客户创建" :value="0"></el-option>
            <el-option label="服务经理创建" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <!-- 提交时间 -->
        <el-form-item label="提交时间">
          <el-date-picker
            v-model="queryParams.submitTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 最后更新时间 -->
        <el-form-item label="最后更新时间">
          <el-date-picker
            v-model="queryParams.updateTime"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 操作 -->
        <el-button type="primary" size="small" @click="doSearch()"
          >查询</el-button
        >
        <el-button type="primary" plain size="small" @click="handleResetQuery()"
          >重置</el-button
        >
      </el-form>
    </div>
    <!-- 表格内容 -->
    <div class="table-container">
      <div class="table-btn">
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="handleAdd()"
          >新增反馈单</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        highlight-current-row
        :border="true"
        :data="tableData"
        stripe
      >
        <!-- 序号 -->
        <el-table-column label="序号" width="50px" align="center">
          <template slot-scope="scope">
            {{ getColumnIndex(scope.$index) }}
          </template>
        </el-table-column>
        <!-- 反馈单号 -->
        <el-table-column
          prop="feedbackFormId"
          label="反馈单号"
          align="center"
          :min-width="$getColumnWidth('feedbackFormId', tableData)"
        >
        </el-table-column>
        <!-- 反馈问题 -->
        <el-table-column
          prop="questionTotal"
          label="反馈问题"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('questionTotal', tableData)"
        >
        </el-table-column>
        <!-- 被驳回 -->
        <el-table-column
          label="被驳回"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('rejectTotal', tableData)"
        >
          <template slot-scope="scope">
            {{ scope.row.rejectTotal }}
          </template>
        </el-table-column>
        <!-- 处理中 -->
        <el-table-column
          prop="ingTotal"
          label="处理中"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('ingTotal', tableData)"
        >
        </el-table-column>
        <!-- 待确认 -->
        <el-table-column
          label="待确认"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('waitingTotal', tableData)"
        >
          <template slot-scope="scope">
            {{ scope.row.waitingTotal }}
          </template>
        </el-table-column>
        <!-- 已关闭 -->
        <el-table-column
          prop="closeTotal"
          label="已关闭"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('closeTotal', tableData)"
        >
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          prop="status"
          label="状态"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('status', tableData)"
        >
          <template slot-scope="scope">
            <span class="warnColor">{{
              scope.row.status === 0 ? "未提交" : ""
            }}</span>
            <span class="blueColor">{{
              scope.row.status === 1 ? "处理中" : ""
            }}</span>
            <span class="successColor">{{
              scope.row.status === 2 ? "已关闭" : ""
            }}</span>
          </template>
        </el-table-column>
        <!-- 创建人 -->
        <el-table-column
          prop="creator"
          label="创建人"
          align="center"
          :min-width="$getColumnWidth('creator', tableData)"
        >
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('createTime', tableData)"
        >
        </el-table-column>
        <!-- 所属经销商 -->
        <!--        <el-table-column
          prop="customerName"
          label="所属经销商"
          show-overflow-tooltip
          align="center"
          min-width="120"
        >
        </el-table-column>-->
        <!-- 提交时间 -->
        <el-table-column
          prop="submitTime"
          label="提交时间"
          width="180"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('submitTime', tableData)"
        >
        </el-table-column>
        <!-- 最后更新时间 -->
        <el-table-column
          prop="updateTime"
          label="最后更新时间"
          width="180"
          show-overflow-tooltip
          align="center"
          :min-width="$getColumnWidth('updateTime', tableData)"
        >
        </el-table-column>
        <!-- 操作 -->
        <el-table-column label="操作" width="150px" fixed="right">
          <template slot-scope="scope">
            <!-- 查看 -->
            <el-button
              size="mini"
              type="text"
              @click="handleEditOrLook(scope.row, 'look')"
              >查看</el-button
            >
            <!-- 编辑 -->
            <el-button
              v-if="scope.row.status === 0"
              size="mini"
              type="text"
              @click="handleEditOrLook(scope.row, 'edit')"
              >编辑</el-button
            >
            <!-- 提交 -->
            <el-button
              v-if="scope.row.status === 0 && scope.row.questionTotal !== 0"
              type="text"
              @click="handleChangeStatus(scope.row, 'submit')"
              >提交</el-button
            >
            <!-- 删除 -->
            <el-button
              v-if="scope.row.questionTotal === 0"
              type="text"
              @click="handleChangeStatus(scope.row, 'delete')"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="pageNum"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <add-dialog ref="addDialog" />
  </div>
</template>

<script>
import listCurd from "@/mixins/listCurd";
import { setStorageNew } from "@/util/localStor";
import {
  feedbackListApi,
  feedbackSubmitApi,
  deleteEmptyFormApi,
} from "@/api/feedbackKD";
import AddDialog from "./components/addDialog.vue";
import componentConfig from "@/mixins/componentConfig";

export default {
  components: { AddDialog },
  mixins: [listCurd, componentConfig],
  data() {
    return {
      queryParams: {}, // 查询参数
      type: "kdFeedback",
      listMethod: feedbackListApi, // 获取表格数据api
    };
  },
  created() {
    // 获取表格数据
    this.getList();
    //获取零部件类别
    this.getTypeList();
  },
  methods: {
    // 查询参数
    getParams() {
      const params = { ...JSON.parse(JSON.stringify(this.queryParams)) };
      if ((params.submitTime || []).length === 2) {
        params.submitTimeStart = params.submitTime?.[0];
        params.submitTimeEnd = params.submitTime?.[1];
      }
      delete params.submitTime;
      if ((params.updateTime || []).length === 2) {
        params.updateTimeStart = params.updateTime?.[0];
        params.updateTimeEnd = params.updateTime?.[1];
      }
      delete params.updateTime;
      return {
        data: {
          ...params,
        },
        page: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      };
    },
    // 新增反馈单
    handleAdd() {
      setStorageNew("qualityData", {});
      this.$refs.addDialog.init();
    },
    // (编辑 | 查看)反馈单
    handleEditOrLook(data = {}, operate) {
      setStorageNew("qualityData", data);
      this.getSetItem();
      this.$router.push({
        path: "/KDaddFeedback/detail",
        query: {
          operate,
        },
      });
    },
    // (提交 | 删除)反馈单
    async handleChangeStatus(row, type) {
      this.getSetItem();
      try {
        await this.$confirm(
          `${
            `确认${type === "submit" ? "提交" : "删除"}质量反馈单:` +
            row.feedbackFormId
          }？`,
          "提示",
          {
            cancelButtonClass: "confirm-btn-close",
            confirmButtonClass: "confirm-btn-confirm",
            type: "warning",
          }
        );
        var res = {};
        if (type === "submit") {
          res = await feedbackSubmitApi({
            data: {
              feedbackFormId: row.feedbackFormId,
              customerId: row.customerId,
            },
          });
        } else if (type === "delete") {
          res = await deleteEmptyFormApi(row.feedbackFormId);
        }

        if (res.status == 0) {
          this.$DonMessage.success("操作成功");
          this.getList();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {}
    },
  },
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
